@if (enabledPlayer$ | async; as livestream) {
  <fw-storyblock
    [attr.channel]="livestream.channel"
    [attr.playlist]="livestream.playlist"
    mode="pinned"
    autoplay="true"
  ></fw-storyblock>
}
